import { useIntl } from 'react-intl';
import { Box, FormControlLabel, Stack } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import PropTypes from 'prop-types';
import { Position } from '@xyflow/react';
import { BaseNode } from 'pages/assistants/builder/components/nodes/baseNode';
import { CompactNodeField } from 'pages/assistants/builder/components/nodes/compactNodeField';

export function ClassificationNode({ id, data, onEditNode, onDeleteNode }) {
  const { formatMessage: msg } = useIntl();
  const { providerCode, modelCode, classificationItems = [], outputVar, fileClassification } = data;

  return (
    <BaseNode
      id={id}
      icon="clear_all_icon"
      nodeData={{ ...data, label: msg({ id: 'field.classification.processor.label' }) }}
      color="error"
      handleConf={[
        { type: 'target', position: Position.Top, style: { background: 'orange' } },
        { type: 'target', position: Position.Left },
        { type: 'source', position: Position.Right }
      ]}
      key={`node-${id}`}
      onEditNode={onEditNode}
      onDeleteNode={onDeleteNode}
    >
      <Stack spacing={1.5} sx={{ p: 1, width: 280 }}>
        <CompactNodeField label={msg({ id: 'field.provider.label' })} value={providerCode} />

        <CompactNodeField label={msg({ id: 'field.model.label' })} value={modelCode} />

        <Box
          sx={{
            borderRadius: 2,
            p: 2,
            backgroundColor: '#fafafa55',
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
          }}
        >
          <Stack spacing={0.5}>
            {classificationItems.map((item, index) => (
              <Box
                key={index}
                sx={{
                  px: 1,
                  py: 0.5,
                  backgroundColor: 'white',
                  borderRadius: 1,
                  '&:hover': { backgroundColor: '#f8f9fa' }
                }}
              >
                - {item}
              </Box>
            ))}
          </Stack>
        </Box>

        <CompactNodeField label={msg({ id: 'field.outputvar.label' })} value={outputVar} />

        <FormControlLabel
          control={<Checkbox checked={!!fileClassification} disabled />}
          label={msg({ id: 'field.classification.file.label' })}
        />
      </Stack>
    </BaseNode>
  );
}

ClassificationNode.propTypes = {
  id: PropTypes.string,
  data: PropTypes.shape({
    providerCode: PropTypes.string,
    modelCode: PropTypes.string,
    classificationItems: PropTypes.arrayOf(PropTypes.string),
    outputVar: PropTypes.string,
    fileClassification: PropTypes.bool
  }),
  onEditNode: PropTypes.func.isRequired,
  onDeleteNode: PropTypes.func.isRequired
};
